import { useQuery } from '@tanstack/react-query';
import { loanApiService } from '../services/loanApi';
import type { LoanLimits } from '../types/loan';

export const LoanLimitsQueryKeys = {
  loanLimits: ['loan-limits'],
};

interface UseLoanLimitsReturn {
  getLoanLimits: () => Promise<LoanLimits | undefined>;
  loanLimits: LoanLimits | undefined;
  isLoading: boolean;
}

export function useLoanLimits(
  fetchLoanLimits: boolean = false
): UseLoanLimitsReturn {
  const loanLimitsQuery = useQuery({
    queryKey: [LoanLimitsQueryKeys.loanLimits],
    queryFn: () => loanApiService.getLoanLimits(),
    enabled: fetchLoanLimits,
  });

  const getLoanLimits = async () => {
    const result = await loanLimitsQuery.refetch();
    return result.data;
  };

  return {
    getLoanLimits,
    loanLimits: loanLimitsQuery.data,
    isLoading: loanLimitsQuery.isLoading,
  };
}
